import { TextCodes } from '@api/types/translation/TextCodes';
import { Button, SmartLink } from '@components';
import { useAppSelector } from '@hooks';
import { Box, styled } from '@mui/material';
import { getSpecialPage } from '@store/app/app.slice';
import { getSearchQuery } from '@store/search/search.slice';
import { t } from '@translations';

// STYLES
//--------

const Wrapper = styled(Box)`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50px;
  margin-bottom: 40px;
`;

// TYPES
//-------

export type GoToFullSearchProps = {
  totalCount?: string;
};

export const GoToFullSearch = ({ totalCount = '?' }: GoToFullSearchProps) => {
  const buttonLabel = t(TextCodes.Search.GoToFullSearch, { totalCount });
  const currentQuery = useAppSelector(getSearchQuery);
  const searchResultsUrl = useAppSelector(getSpecialPage('searchResultsPage')) || '';

  if (!searchResultsUrl) {
    return (
      <Wrapper>
        <Button>{buttonLabel}</Button>
      </Wrapper>
    );
  }
  return (
    <Wrapper>
      <SmartLink href={`${searchResultsUrl}?query=${currentQuery}`}>
        <Button>{buttonLabel}</Button>
      </SmartLink>
    </Wrapper>
  );
};
